<template>
  <div>
    <v-layout sm6>
        <v-flex>
            <content-field
            label="Add new IP"
            :error="$v.newIpItem.ip"
            v-model="newIpItem.ip"/>
        </v-flex>
        <v-btn
            :disabled="!newIpItem.ip || $v.newIpItem.ip.$invalid"
            color="success"
            @click="addIp()">
        Add IP
        </v-btn>
    </v-layout>

    <v-layout>
      <v-flex xs12 sm6>
        <v-list>
          <v-list-tile
            v-for="item in blockedIps"
            :key="item.id"
            no-action
          >
              <v-list-tile-content>
                <v-list-tile-title v-text="item.ip"></v-list-tile-title>
              </v-list-tile-content>
              <v-list-tile-action>

                <v-btn
                  color="error"
                  :disabled="!isWriteAvailable"
                  fab flat
                  @click.stop="deleteIp(item.id)"
                >
                  <v-icon>delete</v-icon>
                </v-btn>
              </v-list-tile-action>
          </v-list-tile>
        </v-list>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
import ContentField from '@/components/shared/ContentField'
import { mapActions, mapGetters } from 'vuex'
import { pathOr } from 'ramda'
import { required, ipAddress } from 'vuelidate/lib/validators'
import mixins from '@/utils/mixins'

  export default {
    name: 'blockedIps',
    mixins: [mixins.isWriteAvailable],
    components: {
      ContentField
    },
    data () {
      return {
        items: {},
        newIpItem: {
          ip: '',
          description: 'from BO'
        },
        // DON'T DELETE! need for isWriteAvailable mixin
        scopeForWrite: 'registration:write'
      }
    },
    validations () {
        return {
            newIpItem: {
                ip: { required, ipAddress }
            }
        }
    },
    computed: {
      ...mapGetters(['blockedIps'])
    },
    methods: {
      ...mapActions([
        'addBlockedIp',
        'fetchBlockedIps',
        'deleteBlockedIp',
        'showResultErrorMessage'
      ]),
      async addIp () {
        try {
          await this.addBlockedIp(this.newIpItem)
          this.newIpItem.ip = ''
          this.$v.$reset()
          await this.fetchBlockedIps()
        } catch (err) {
          this.showResultErrorMessage(pathOr('Failed to add IP', ['response', 'data', 'ValidationFailures', '0', 'errorMessage'], err))
        }
      },
      async deleteIp (id) {
        try {
          await this.deleteBlockedIp(id)
          await this.fetchBlockedIps()
        } catch (err) {
          this.showResultErrorMessage(pathOr('Failed to add IP', ['response', 'data', 'Message'], err))
        }
      },
    },
    beforeMount () {
      this.fetchBlockedIps()
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/pages/Registration/Settings/blockedIps.vue